import { render, staticRenderFns } from "./UpdateCases.vue?vue&type=template&id=44f35a36&scoped=true"
import script from "./UpdateCases.vue?vue&type=script&lang=js"
export * from "./UpdateCases.vue?vue&type=script&lang=js"
import style0 from "./UpdateCases.vue?vue&type=style&index=0&id=44f35a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f35a36",
  null
  
)

export default component.exports